// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-size {
  font-size: 40px;
}

.icon-pack-style {
  background-color: #ececec;
}

.photo-label {
  position: absolute;
  margin: auto;
  padding: 10px;
  text-align: center;
  width: 100%;
  margin-top: 2em;
}

.image-class {
  margin: 0 auto;
}

@media (min-width: 1024px) {
  .photo-align {
    box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.1), 0px 15px 30px rgba(0, 0, 0, 0.05);
    align-items: center;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2em;
    border-radius: 30px;
    width: 75%;
  }
  .photo-label {
    position: relative;
  }
  .image-class {
    margin: 0 auto;
    width: 35%;
    margin-top: 2em;
  }
}
@media (max-width: 640px) {
  .image-class {
    margin: 0 auto;
    width: 90%;
    margin-top: 12em;
  }
}
@media (min-width: 641px) and (max-width: 1023px) {
  .image-class {
    margin: 0 auto;
    width: 35%;
    margin-top: 9em;
  }
}
.modal-dialog {
  z-index: 30000 !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
